export default "__VITE_ASSET__Dq2f5V1D__"